import {sendGlobalInfo} from "@/utils/actions";
import { mapGetters,mapActions } from 'vuex'
import {
  loadMicroApp
} from "qiankun"
import {comp} from "@/micro/apps";
import {contentExtend} from "@/utils/common";
import Vue from 'vue'
import i18n from '@/utils/i18n'
export const mixin = {
    data(){
        return {
          publicApp:null,
          publicAppMounted:false
        }
    },
    computed: {
        ...mapGetters([
            'userInfo',
            'projectInfo',
            'buttonPageObj',
            'secondRouters',
            'lastAlertPoint',
            'language',
            'theme',
            'factorInfo',
            'pageConfig'
        ])
    },
    watch:{
        language(newVal,oldVal){
            if(newVal){
                sendGlobalInfo({'language':newVal})
            }
        },
        userInfo(newVal,oldVal){
            if(newVal){
                sendGlobalInfo({'userInfo':newVal})
            }
        },
        projectInfo(newVal,oldVal){
            if(newVal){
                sendGlobalInfo({'projectInfo':newVal})
            }
        },
        buttonPageObj(newVal,oldVal){
            if(newVal){
                sendGlobalInfo({'buttonPageObj':newVal})
            }
        },
        secondRouters(newVal){
            if(newVal){
                sendGlobalInfo({'secondRouters':newVal})
            }
        },
        lastAlertPoint(newVal,oldVal){
            if(newVal) {
                sendGlobalInfo({'lastAlertPoint': newVal})
            }
        },
        theme(newVal,oldVal){
            if(newVal){
                sendGlobalInfo({'theme':newVal})
            }
        },
        factorInfo(newVal,oldVal){
          if(newVal){
              sendGlobalInfo({'factorInfo':newVal})
          }
        },
        pageConfig(newVal, oldVal) {
            if(newVal) {
                sendGlobalInfo({'pageConfig': newVal})
            }
        }
    },
    mounted() {
        sendGlobalInfo({
            projectInfo:this.projectInfo,
            userInfo:this.userInfo,
            buttonPageObj:this.buttonPageObj,
            secondRouters:this.secondRouters,
            lastAlertPoint:this.lastAlertPoint,
            floatzIndex:this.floatzIndex,
            theme: this.theme,
            language:this.language,
            factorInfo:this.factorInfo
        })
        this.publicApp = loadMicroApp(comp)
        this.publicApp.mountPromise.then(() => {
        console.log('加载完毕')
        //ssh 不需要重复绑定组件
        for(let component in window.publicComponents){
            Vue.component(component, contentExtend(window.publicComponents[component]))
        }
        // Vue.component('SvgIcon',contentExtend(window.publicComponents.SvgIcon))
        // Vue.component('noData',contentExtend(window.publicComponents.noData))
        this.publicAppMounted = true
        })

        //两秒过后如果publicApp加载失败也把layout放开
        setTimeout(() => {
        if(!this.publicAppMounted){
            this.publicAppMounted = true
        }
        },2000)
    },
    methods:{
        logoutUser(){
            this.LogOut()
        },
        ...mapActions({
            LogOut: 'LogOut'
        })
    }
}